const rqrTypesMap = {
  1: 'Compliance',
  2: 'Quality',
  4: 'In flight review',
}

export default rqrTypeCode => rqrTypesMap[rqrTypeCode] || 'RQR Type not mapped yet'

export { rqrTypesMap }